export default "__VITE_ASSET__165b0ecb__"